var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"id":"to-top-button","title":"Go to top"},on:{"click":function($event){return _vm.topFunction()}}},[_c('i',{staticClass:"fas fa-angle-up",staticStyle:{"font-size":"1.7em"}}),_c('br'),_c('span',{staticStyle:{"font-size":"0.8em"}},[_vm._v("Back to")]),_c('br'),_c('span',{staticStyle:{"font-size":"0.8em"}},[_vm._v("Top")])])
}
var staticRenderFns = []

export { render, staticRenderFns }